export function render(text, rawText, refUrl) {
  const shareText = this.getText(text);
  const url = this.getShareUrl(shareText, refUrl);

  return `<a href="${url}" target="_blank" rel="noopener nofollow noreferrer">` +
      '<svg viewBox="-3 -3 30 30" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 ' +
          '1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" fill="currentcolor"/>' +
      '</svg></a>';
}

const CHAR_LIMIT = 120;
export function getText(text) {
  let chunk = text.trim();
  if (chunk.length > CHAR_LIMIT - 2) {
    chunk = chunk.slice(0, CHAR_LIMIT - 3).trim() + '\u2026';
  }
  return chunk;
}

export function getShareUrl(text, refUrl) {
  return `https://x.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(refUrl)}`;
}

export function action(event, item) {
  event.preventDefault();
  const popup = item.ownerDocument.defaultView.open(
    item.firstChild.href,
    'share_via_twitter',
    'height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640'
  );
  popup.opener = null;
}

export const name = 'x';
